import { Container, Section } from '@resolute/ui';

import { Reveal } from '@/components/motion/reveal';

export function AboutHero() {
  return (
    <Section spacing="lg" className="border-b border-border bg-muted/30">
      <Container>
        <Reveal>
          <p className="text-sm font-medium uppercase tracking-widest text-secondary">
            About Resolute
          </p>
        </Reveal>

        <div className="mt-4 grid gap-8 lg:grid-cols-[3fr_2fr] lg:items-end lg:gap-12">
          <Reveal>
            <h1 className="text-balance font-display text-display-md font-semibold tracking-tight">
              We Didn&apos;t List Properties.
              <span className="block text-muted-foreground">We Verified Them First.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="text-pretty text-lg text-muted-foreground lg:pb-2">
              A transparency-first real estate platform for India&apos;s growth corridors —
              verified inventory, investment intelligence and a first-class journey for every
              buyer, wherever they&apos;re searching from.
            </p>
          </Reveal>
        </div>
      </Container>
    </Section>
  );
}
